module.exports = __webpack_public_path__ + "img/badge-new.193c5ab9.png";